export const SET_ALERT = 'SET_ALERT'
export const REMOVE_ALERT = 'REMOVE_ALERT'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'
export const USER_LOADED = 'USER_LOADED'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT = 'LOGOUT'
export const UPDATE_USER = 'UPDATE_USER'
export const DELETE_USER = 'DELETE_USER'
export const USER_ERROR = 'USER_ERROR'
export const GET_POSTS = 'GET_POSTS'
export const GET_POST = 'GET_POST'
export const GET_MY_POSTS = 'GET_MY_POSTS'
export const CREATE_POST = 'CREATE_POST'
export const UPDATE_POST = 'UPDATE_POST'
export const DELETE_POST = 'DELETE_POST'
export const CREATE_PINNED = 'CREATE_PINNED'
export const DELETE_PINNED = 'DELETE_PINNED'
export const CREATE_FEATURED = 'CREATE_FEATURED'
export const DELETE_FEATURED = 'DELETE_FEATURED'
export const POST_LOADING = 'POST_LOADING'
export const CREATE_COMMENT = 'CREATE_COMMENT'
export const DELETE_COMMENT = 'DELETE_COMMENT'
export const POST_ERROR = 'POST_ERROR'
export const PROFILE_LOADING = 'PROFILE_LOADING'
export const GET_PROFILE = 'GET_PROFILE'
export const PROFILE_ERROR = 'PROFILE_ERROR'
export const SEARCH_PROFILE = 'SEARCH_PROFILE'
export const SEARCH_POST = 'SEARCH_POST'
export const SEARCH_ERROR = 'SEARCH_ERROR'
export const SEARCH_QUERY = 'SEARCH_QUERY'
